var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../layout/components/loaders');
var buttonElement = require('../components/button');
var flash = require('../components/flash');
var choices = require('../libs/choices');
var equipmentModel = require('../equipment/models/equipment');

var state = {
  mapModes: [],
  classOptions: [],
  loading: false,
  saving: false,
  message: prop([]),
  error: prop([]),
};

function resetAlerts() {
  state.message([]);
  state.error([]);
}

function setMessage(items) {
  state.message(items);
}

function setError(items) {
  state.error(items);
}

var nextId = 1;

function createMapMode(data) {
  return {
    id: nextId++,
    name: prop((data && data.name) ? data.name : ''),
    classesIncluded: prop(Array.isArray(data && data.classesIncluded) ? data.classesIncluded.slice() : []),
  };
}

function buildClassOptions(classTree) {
  var options = [];
  var seen = {};
  function addNode(node, path) {
    if (!node || !node.name || node.name === 'Overview') return;
    var currentPath = path ? path + ' > ' + node.name : node.name;
    if (!seen[node.name]) {
      options.push({ value: node.name, key: currentPath });
      seen[node.name] = true;
    }
    if (Array.isArray(node.children)) {
      node.children.forEach(function (child) { addNode(child, currentPath); });
    }
  }
  (classTree && classTree.categories ? classTree.categories : []).forEach(function (category) {
    addNode(category, '');
  });
  return options;
}

function loadClassOptions() {
  return equipmentModel.getClassTree()
    .then(function (tree) {
      state.classOptions = buildClassOptions(tree);
    })
    .catch(function () {
      state.classOptions = [];
    });
}

function loadMapModes() {
  resetAlerts();
  return loaders.requestWithLoader({
    loader: 'main',
    method: 'GET',
    url: '/api/v1/mapmodes',
  })
  .then(function (res) {
    state.mapModes = Array.isArray(res)
      ? res.map(createMapMode)
      : [];
  })
  .catch(function (err) {
    const msg = (err && err.message) ? err.message : (typeof err === 'string' ? err : 'Failed to load map modes');
    setError([msg]);
    state.mapModes = [];
  });
}

function saveMapModes() {
  resetAlerts();
  var payload = state.mapModes.map(function (mode) {
    return {
      name: String(mode.name() || '').trim(),
      classesIncluded: Array.isArray(mode.classesIncluded()) ? mode.classesIncluded().slice() : [],
    };
  });
  state.saving = true;
  return loaders.requestWithLoader({
    loader: 'submit',
    method: 'PUT',
    url: '/api/v1/mapmodes',
    body: { data: payload },
  })
  .then(function (res) {
    setMessage(['Saved map modes']);
    if (Array.isArray(res)) {
      state.mapModes = res.map(createMapMode);
    }
  })
  .catch(function (err) {
    const msg = (err && err.message) ? err.message : (typeof err === 'string' ? err : 'Failed to save map modes');
    setError([msg]);
  })
  .finally(function () {
    state.saving = false;
  });
}

function addMapMode() {
  state.mapModes.push(createMapMode({}));
}

function removeMapMode(id) {
  state.mapModes = state.mapModes.filter(function (mode) {
    return mode.id !== id;
  });
}

var mapModesSettings = {
  oninit: function () {
    state.loading = true;
    return Promise.all([loadClassOptions(), loadMapModes()])
    .finally(function () {
      state.loading = false;
    });
  },
  view: function () {
    return m('div', [
      m('h3.mt0', 'Map Modes'),
      m('p.mt0.mb2.gray', 'Create views and select which equipment classes appear on the map.'),
      state.error() && state.error().length ? m(flash, { items: state.error(), bg: 'bg-red' }) : null,
      state.message() && state.message().length ? m(flash, { items: state.message(), bg: 'bg-green' }) : null,
      state.loading
        ? m('div.tc', [
          m('img.h1', { src: '/images/loading-bars.svg' })
        ])
        : state.mapModes.length
          ? state.mapModes.map(function (mode) {
            return m('div.ba.b--mid-gray.bw1.br2.pa3.mb3', { key: mode.id }, [
              m('div', [
                m('label.db', 'Map Mode Name'),
                m('div.flex', [
                  m('input.form-control', {
                    value: mode.name(),
                    oninput: function (e) { mode.name(e.target.value); },
                    autocomplete: 'off',
                  }),
                  m(buttonElement, {
                    label: m('i', { class: 'ion-android-delete f3', title: 'Remove' }),
                    class: 'red ml2',
                    func: function () { removeMapMode(mode.id); },
                  }),
                ]),
              ]),
              m('div.mt2', [
                m('label.db', 'Classes Included'),
                m(choices, {
                  data: state.classOptions,
                  value: mode.classesIncluded,
                  onchange: m.redraw,
                  placeholderValue: 'Select Classes',
                }),
              ]),
            ]);
          })
          : m('div.gray', 'No map modes yet. Add one to get started.'),
      m('div.mt3.flex.flex-wrap.items-center.justify-between', [
        m(buttonElement, {
          label: 'Add Map Mode',
          class: 'blue',
          style: { minWidth: '33%' },
          func: addMapMode,
        }),
        m(buttonElement, {
          label: state.saving ? 'Saving...' : 'Save',
          class: 'green',
          style: { minWidth: '33%' },
          func: saveMapModes,
        }),
      ]),
    ]);
  }
};

module.exports = mapModesSettings;
